import * as Yup from 'yup'
export function validateStep1(values) {
    return Yup.object().shape({
        email: Yup.string().email('Please enter a valid email').required('This field is required'),
        first_name: Yup.string().required('This field is required'),
        last_name: Yup.string().required('This field is required'),
        reps_id: Yup.string().required('This field is required'),
        country: Yup.string().required('This field is required'),
        primary_number: Yup.string().matches(/[0-9]+/gi, "Enter number only").required('Required'),
    });
}
export function validateStep2(values) {
    return Yup.object().shape({
        username: Yup.string().required('This field is required').min(5, 'Username should be 5 chars minimum.'),
        password: Yup.string().required('This field is required').min(6, 'Password should be 6 chars minimum.'),
        confirm_password: Yup.string().required('This field is required').oneOf([Yup.ref('password'), null], 'Password must match'),
        secquestion_1: Yup.string().required('This field is required'),
        secquestion_1_answer: Yup.string().required('This field is required')
    });
}


export function validateStep4_individual(values) {
    return Yup.object().shape({
        reps_id: Yup.string().required('This field is required'),
        first_name: Yup.string().required('This field is required'),
        last_name: Yup.string().required('This field is required'),
        date_birth_options: Yup.string().required('This field is required'),

        date_birth: Yup.string().notRequired().when('date_birth_options', {
          is: (val) => val === '1',
          then: Yup.string().required('This field is required'),
          otherwise: Yup.string().notRequired()
        }),
        date_birth_text: Yup.string().notRequired().when('date_birth_options', {
          is: (val) => val === '2',
          then: Yup.string().required('This field is required'),
          otherwise: Yup.string().notRequired()
        }),


        citizenship: Yup.string().required('This field is required'),
        citizen_country: Yup.string().notRequired().when('citizenship', {
          is: (val) => val === '2',
          then: Yup.string().required('This field is required'),
          otherwise: Yup.string().notRequired()
        }),
        type_id: Yup.string().required('This field is required'),
        //id_number: Yup.string().required('This field is required'),
        address1: Yup.string().required('This field is required'),
        city: Yup.string().required('This field is required'),
        state: Yup.string().required('This field is required'),
        country: Yup.string().required('This field is required'),
        postal_code: Yup.string().required('This field is required'),
        primary_number: Yup.string().required('This field is required'),
        email: Yup.string().email('Please enter a valid email').required('This field is required'),
        marital_status: Yup.string().required('This field is required'),
        //no_dependents: Yup.string().required('This field is required'),
    });
}

export function validateStep4_joint(values) {
    return Yup.object().shape({

        reps_id: Yup.string().required('This field is required'),
        first_name: Yup.string().required('This field is required'),
        last_name: Yup.string().required('This field is required'),
        date_birth_options: Yup.string().required('This field is required'),
        date_birth: Yup.string().notRequired().when('date_birth_options', {
          is: (val) => val === '1',
          then: Yup.string().required('This field is required'),
          otherwise: Yup.string().notRequired()
        }),
        date_birth_text: Yup.string().notRequired().when('date_birth_options', {
          is: (val) => val === '2',
          then: Yup.string().required('This field is required'),
          otherwise: Yup.string().notRequired()
        }),
        citizenship: Yup.string().required('This field is required'),
        citizen_country: Yup.string().notRequired().when('citizenship', {
          is: (val) => val === '2',
          then: Yup.string().required('This field is required'),
          otherwise: Yup.string().notRequired()
        }),
        type_id: Yup.string().required('This field is required'),
        //id_number: Yup.string().required('This field is required'),
        address1: Yup.string().required('This field is required'),
        city: Yup.string().required('This field is required'),
        state: Yup.string().required('This field is required'),
        country: Yup.string().required('This field is required'),
        postal_code: Yup.string().required('This field is required'),
        primary_number: Yup.string().required('This field is required'),
        email: Yup.string().email('Please enter a valid email').required('This field is required'),
        marital_status: Yup.string().required('This field is required'),
        //no_dependents: Yup.string().required('This field is required'),

        joint_first_name: Yup.string().required('This field is required'),
        joint_last_name: Yup.string().required('This field is required'),
        joint_date_birth_options: Yup.string().required('This field is required'),
        joint_date_birth: Yup.string().notRequired().when('joint_date_birth_options', {
          is: (val) => val === '1',
          then: Yup.string().required('This field is required'),
          otherwise: Yup.string().notRequired()
        }),
        joint_date_birth_text: Yup.string().notRequired().when('joint_date_birth_options', {
          is: (val) => val === '2',
          then: Yup.string().required('This field is required'),
          otherwise: Yup.string().notRequired()
        }),
        joint_citizenship: Yup.string().required('This field is required'),
        joint_citizen_country: Yup.string().notRequired().when('joint_citizenship', {
          is: (val) => val === '2',
          then: Yup.string().required('This field is required'),
          otherwise: Yup.string().notRequired()
        }),
        joint_type_id: Yup.string().required('This field is required'),
        //joint_id_number: Yup.string().required('This field is required'),
        joint_address1: Yup.string().required('This field is required'),
        joint_city: Yup.string().required('This field is required'),
        joint_state: Yup.string().required('This field is required'),
        joint_country: Yup.string().required('This field is required'),
        joint_postal_code: Yup.string().required('This field is required'),
        joint_primary_number: Yup.string().required('This field is required'),
        joint_email: Yup.string().email('Please enter a valid email').required('This field is required'),
        joint_marital_status: Yup.string().required('This field is required'),
        //joint_no_dependents: Yup.string().required('This field is required'),
    });
}


export function validatefinancial(values) {
    return Yup.object().shape({
        years_stock: Yup.string().required('This field is required'),
        years_options: Yup.string().required('This field is required'),
        years_mutual: Yup.string().required('This field is required'),
        years_futures: Yup.string().required('This field is required'),
        years_forex: Yup.string().required('This field is required'),
        finance_annual: Yup.string().required('This field is required'),
        finance_marginal: Yup.string().required('This field is required'),
        finance_totalnet: Yup.string().required('This field is required'),
        finance_liquidnet: Yup.string().required('This field is required'),
        finance_sourceincome: Yup.string().required('This field is required'),
        number_contracts: Yup.string().required('This field is required'),
        name_contracts: Yup.string().required('This field is required'),
        finance_amount: Yup.string().required('This field is required'),
        finance_fund: Yup.string().required('This field is required'),

        /*specify_finance_annual: Yup.string().notRequired().when('finance_annual', {
          is: (val) => val == '1',
          then: Yup.string().required('This field is required'),
          otherwise: Yup.string().notRequired()
        }),*/

        /*specify_finance_totalnet: Yup.string().notRequired().when('finance_totalnet', {
          is: (val) => val == '1',
          then: Yup.string().required('This field is required'),
          otherwise: Yup.string().notRequired()
        }),
        specify_finance_liquidnet: Yup.string().notRequired().when('finance_liquidnet', {
          is: (val) => val == '1',
          then: Yup.string().required('This field is required'),
          otherwise: Yup.string().notRequired()
        }),*/

    });
}


export function validatecapcha(values) {
    return Yup.object().shape({
        captcha_text: Yup.string().required('Enter the correct code.').oneOf([Yup.ref('captcha_value'), null], 'Enter the correct code.'),
    });
}
